/* ============================================================
   Dreaver quiz — modular, section-based engine.
   Each quiz step is its own Shopify section; steps register with a
   shared Alpine.store('quiz') in DOM order, so the number/order of
   steps is fully editable in the theme editor. Steps may declare a
   visibility CONDITION (show only when an answer matches), and the
   navigation skips steps whose condition isn't met (branching).
   ============================================================ */
document.addEventListener('alpine:init', function () {

  Alpine.store('quiz', {
    current: 0,
    steps: [],            // ordered meta objects, one per registered step
    answers: {},
    booted: false,

    /* global config (set by the quiz-controls section) */
    redirectUrl: 'https://dreaver.nl/products/dreaver-elevate-pro',
    progressTotal: 10,
    logo: 'https://dreaver.nl/cdn/shop/files/Dreaver_Logo_Petrol.svg?v=1747058277&width=135',
    footerText: '',
    labelDefault: 'Doorgaan',
    labelClaim: 'Claim je korting',
    timer: { mm: 7, ss: 24 },
    claiming: false,
    loaderPhase: 0,
    _timers: [],

    setConfig: function (cfg) {
      var self = this;
      Object.keys(cfg || {}).forEach(function (k) {
        if (cfg[k] !== undefined && cfg[k] !== null && cfg[k] !== '') self[k] = cfg[k];
      });
      if (cfg && cfg.timer) this.timer = cfg.timer;
    },

    /* --- registration (called by each step's x-init, in DOM order) --- */
    register: function (meta) {
      var m = Object.assign({
        answerKey: '', multi: false, autoAdvance: false, requiresAnswer: false,
        isLoader: false, isClaim: false, showContinue: false, hideBack: false,
        loaderMs: 7800, kind: 'question', cond: null,
      }, meta || {});
      this.steps.push(m);
      var idx = this.steps.length - 1;
      if (!this._bootScheduled) {
        this._bootScheduled = true;
        setTimeout(this.boot.bind(this), 0); // run after every step has registered
      }
      return idx;
    },

    boot: function () {
      if (this.booted) return;
      this.booted = true;
      var active = this.activeIndexes();
      this.current = active.length ? active[0] : 0;
      this.startTimer();
      this.onEnter();
    },

    /* --- conditions / active steps --- */
    condMet: function (meta) {
      if (!meta || !meta.cond || !meta.cond.key) return true;
      var a = this.answers[meta.cond.key];
      var vals = meta.cond.values || [];
      var inSet;
      if (Array.isArray(a)) inSet = a.some(function (x) { return vals.indexOf(x) >= 0; });
      else inSet = vals.indexOf(a) >= 0;
      return meta.cond.op === 'not' ? !inSet : inSet;
    },
    activeIndexes: function () {
      var self = this;
      var out = [];
      this.steps.forEach(function (m, i) { if (self.condMet(m)) out.push(i); });
      return out;
    },
    currentMeta: function () { return this.steps[this.current] || {}; },
    isCurrent: function (i) { return this.current === i; },

    /* --- progress --- */
    _pos: function () {
      var active = this.activeIndexes();
      var p = active.indexOf(this.current);
      return { pos: p < 0 ? 0 : p, total: active.length };
    },
    stepNumber: function () { return this._pos().pos + 1; },
    progress: function () {
      var pt = this._pos();
      if (pt.total <= 1) return 100;
      var t = Math.max(0, Math.min(1, pt.pos / (pt.total - 1)));
      var eased = 1 - Math.pow(1 - t, 1.6);
      return Math.round(eased * 100);
    },

    /* --- navigation (skips steps whose condition isn't met) --- */
    next: function () {
      for (var i = this.current + 1; i < this.steps.length; i++) {
        if (this.condMet(this.steps[i])) { this.current = i; break; }
      }
      window.scrollTo({ top: 0, behavior: 'smooth' });
      this.onEnter();
    },
    back: function () {
      // Cancel any pending auto-advance timer, and skip loader/interstitial
      // steps (they only auto-advance forward) so Back lands on the previous question.
      this._timers.forEach(function (id) { clearTimeout(id); clearInterval(id); });
      this._timers = [];
      for (var i = this.current - 1; i >= 0; i--) {
        if (this.condMet(this.steps[i]) && !this.steps[i].isLoader) { this.current = i; break; }
      }
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },

    onEnter: function () {
      var self = this;
      var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this._timers.forEach(function (id) { clearTimeout(id); clearInterval(id); });
      this._timers = [];
      var meta = this.currentMeta();
      if (meta.isLoader) {
        this.loaderPhase = 0;
        var iv = setInterval(function () {
          self.loaderPhase++;
          if (self.loaderPhase > 4) clearInterval(iv);
        }, reduced ? 80 : 1100);
        this._timers.push(iv);
        this._timers.push(setTimeout(function () { self.next(); }, reduced ? 500 : (meta.loaderMs || 7800)));
      }
    },

    /* --- answers --- */
    select: function (key, value) {
      this.answers[key] = value;
      if (this.currentMeta().autoAdvance) this.next();
    },
    toggle: function (key, value) {
      if (!Array.isArray(this.answers[key])) this.answers[key] = [];
      var arr = this.answers[key];
      var i = arr.indexOf(value);
      if (i >= 0) arr.splice(i, 1); else arr.push(value);
    },
    isSelected: function (key, value) {
      var a = this.answers[key];
      return Array.isArray(a) ? a.indexOf(value) >= 0 : a === value;
    },

    /* --- continue / back button state --- */
    canContinue: function () {
      var m = this.currentMeta();
      if (!m.requiresAnswer) return true;
      var a = this.answers[m.answerKey];
      return m.multi ? (Array.isArray(a) && a.length > 0) : !!a;
    },
    showBack: function () { return this._pos().pos > 0 && !this.currentMeta().hideBack; },
    showContinue: function () { return !!this.currentMeta().showContinue; },
    continueLabel: function () {
      var m = this.currentMeta();
      return m.continueLabel || (m.isClaim ? this.labelClaim : this.labelDefault);
    },
    continueAction: function () {
      if (this.currentMeta().isClaim) return this.claim();
      this.next();
    },

    claim: function () {
      if (this.claiming) return;
      this.claiming = true;
      var url = this.redirectUrl;
      setTimeout(function () { window.location.href = url; }, 500);
    },

    /* --- reservation timer --- */
    formattedTimer: function () {
      var pad = function (n) { return String(n).padStart(2, '0'); };
      return pad(this.timer.mm) + ':' + pad(this.timer.ss);
    },
    startTimer: function () {
      var self = this;
      setInterval(function () {
        if (self.timer.mm === 0 && self.timer.ss === 0) return;
        if (self.timer.ss > 0) self.timer.ss--;
        else { self.timer.mm--; self.timer.ss = 59; }
      }, 1000);
    },
  });

  /* ---- per-step component: registers itself + exposes its index ---- */
  Alpine.data('quizStep', function (id) {
    var meta = {};
    try {
      var node = document.getElementById('quizmeta-' + id);
      if (node) meta = JSON.parse(node.textContent) || {};
    } catch (e) { meta = {}; }
    return {
      idx: -1,
      _proofDone: false,
      options: meta.options || [],
      answerKey: meta.answerKey || '',
      multi: !!meta.multi,
      init: function () {
        this.idx = this.$store.quiz.register(meta);
      },
      mine: function () { return this.$store.quiz.isCurrent(this.idx); },
      // option click: multi -> toggle, single -> select (may auto-advance)
      pick: function (value) {
        if (this.multi) this.$store.quiz.toggle(this.answerKey, value);
        else this.$store.quiz.select(this.answerKey, value);
      },
      sel: function (value) { return this.$store.quiz.isSelected(this.answerKey, value); },
      // proof carousel: init Swiper the first time this step becomes current
      syncProof: function (swiperSel, pagerSel) {
        if (this._proofDone || !this.mine()) return;
        if (typeof Swiper === 'undefined') return;
        this._proofDone = true;
        var el = this.$el.querySelector(swiperSel);
        if (!el) return;
        new Swiper(el, {
          slidesPerView: 1, spaceBetween: 12, loop: true,
          autoplay: { delay: 3500, disableOnInteraction: false },
          pagination: { el: this.$el.querySelector(pagerSel), clickable: true },
        });
      },
    };
  });

});
